
<template>
  <div>
    <el-form
      class="layoutForm"
      ref="layoutForm"
      :model="formData"
      :label-width="formsetting.labelwidth + 'px'"
      :size="formsetting.formsize"
      :disabled="formDisabled"
      :class="{ 'form-disabled': formDisabled }"
    >
      <el-scrollbar>
        <grid-layout
          :layout="layoutTemp"
          :col-num="24"
          :row-height="rowHeight"
          :is-draggable="false"
          :is-resizable="false"
          :vertical-compact="true"
          :responsive="false"
          :use-css-transforms="false"
          :useStyleCursor="false"
          :margin="margin"
        >
          <grid-item
            :key="item.i"
            v-for="item in layoutTemp"
            :x="item.x"
            :y="item.y"
            :w="item.w"
            :h="item.h"
            :i="item.i"
          >
            <el-form-item
              v-if="
                ['TableForm', 'Divider', 'Plain'].indexOf(item.componentType) ==
                -1
              "
              :prop="item.owner + '[0].' + item.id"
              :rules="[
                ...item.rules,
                ...(rules[item.componentType] ? rules[item.componentType] : []),
              ]"
              :class="[
                'el-form--label-' + item.labelPosition,
                'widget-' + item.componentType,
              ]"
              :title="item.tips"
            >
              <template slot="label">
                <div class="name" style="display: inline-block">
                  <span class="icon"></span>
                  <span
                    class="name"
                    v-if="connectFields[item.id]"
                    @click="connectLinkClick(connectFields[item.id])"
                    :class="'connect-link'"
                    >{{ item.name }}</span
                  >
                  <span class="name" v-else>{{ item.name }}</span>
                </div>
              </template>
              <FromItem
                :item="item"
                :formData="formData[item.owner][0]"
                :lockedInfo="
                  lockedFields.find((field) => field.fieldId === item.id)
                "
                @handleUpdate="handleUpdate($event)"
              />
            </el-form-item>
            <w-divider
              v-if="item.componentType === 'Divider'"
              :borderStyle="item.props.borderStyle"
              :borderColor="item.props.borderColor"
              :content-position="item.props.contentposition"
            >
              {{ item.props.text }}
            </w-divider>
            <p
              class="Plain"
              v-if="item.componentType === 'Plain'"
              :style="{
                'justify-content': item.props.contentposition,
                'font-size': item.props.fontsize + 'px',
                'font-family': item.props.fontfamily,
                'font-style': item.props.fontstyle,
                'font-weight': item.props.fontweight,
                color: item.props.textcolor,
              }"
            >
              {{ item.props.text }}
            </p>
            <el-form-item
              class="TableForm"
              v-if="item.componentType === 'TableForm'"
              :prop="item.id + ''"
              :class="['el-form--label-' + item.labelPosition]"
              :title="item.tips"
            >
              <template slot="label">
                <div class="name" style="display: inline-block">
                  <span class="icon"></span>
                  {{ item.name }}
                </div>
              </template>
              <template>
                <tableForm
                  v-if="item.componentType === 'TableForm'"
                  :ref="item.id"
                  :form="formData[item.id]"
                  :table="item"
                  :lockedFields="lockedFields"
                  :connectFields="connectFields"
                  @AddNewBlankRow="AddNewBlankRow"
                  @handleUpdate="handleUpdate"
                  @connectLinkClick="connectLinkClick"
                />
              </template>
            </el-form-item>
          </grid-item>
        </grid-layout>
      </el-scrollbar>
    </el-form>
  </div>
</template>

<script>
import WDivider from '@/views/Report/FormEditor/extendForms/WDivider'
import FromItem from '@/views/Report/FormEditor/formitem'
import tableForm from './tableForm'
import { GridLayout, GridItem } from 'vue-grid-layout'
import fromSetting from '@/views/Report/FormEditor/mixins/formSetting'
export default {
  mixins: [fromSetting],
  inject: ['formEditStatus'],
  provide() {
    return {
      formDisabled: () => this.formDisabled
    }
  },
  name: 'layoutForm',
  components: {
    FromItem,
    tableForm,
    GridLayout,
    GridItem,
    WDivider
  },
  props: {
    layout: {
      type: Array,
      default() {
        []
      }
    },
    formData: {
      type: Object,
      default() {
        return {}
      }
    },
    connectFields: {
      type: Object,
      default() {
        return {}
      }
    },
    lockedFields: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    layoutTemp() {
      return this.layout.filter(item => item.formatHide !== true && item.visible)
    },
    formDisabled() {
      const status = this.formEditStatus()
      return status === 11 || status === 20 || status === 50
    }
  },
  data() {
    return {
      rules: {
        PhoneNumber: [{ pattern: /(^(\d{3,4}-)?\d{7,8})$|(^0?(13[0-9]|15[012356789]|18[0-9]|14[57])[0-9]{8})$/, message: '请输入正确的电话号码', trigger: ['blur', 'change'] }],
        Email: [{ pattern: /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }],
        IdentityCard: [{ pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: ['blur', 'change'] }]
      },
      // layout: [],
      formsetting: {
        labelPosition: 'top',
        labelwidth: 100,
        formsize: 'small'
      },
      form: {}
    }
  },
  methods: {
    // 新增明细
    AddNewBlankRow(val, index, num) {
      this.$emit('AddNewBlankRow', val, index, num)
    },
    handleUpdate(arg, rowIndex) {
      this.$emit('handleUpdate', arg, rowIndex)
    },
    random(min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
    // 设置table 的数据
    settabledata(data) {
      console.log(data)
      this.form[data.field] = data.data
    },
    submitForm(formName) {
      console.log(this.form)
      let pass = true
      // 调用表格的提交按钮
      for (const k in this.$refs) {
        if (k != 'showform') {
          const pdt = this.$refs[k][0].submitForm('dynamicValidateForm')
          if (!pdt) {
            pass = false
          }
          console.log(pass, '...')
        }
      }
      // 当前表单的校验
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (pass) {
            this.$emit('save', this.form)
          }
        } else {
          console.log('error submit!!')
          this.$emit('save', false)
          return false
        }
      })
    },
    connectLinkClick(infos, rowIndex) {
      this.$emit('connectLinkClick', infos, rowIndex)
    }
  }
}
</script>

<style lang="scss">
.layoutForm {
  &.form-disabled {
    .el-input__suffix,
    .el-input__prefix {
      display: none;
    }
    .is-disabled {
      opacity: 1;
      .el-input__inner,
      .el-textarea__inner {
        background-color: #fff;
        color: #606266;
        cursor: text;
      }
    }
  }
  .el-form-item__error {
    padding-top: 4px !important;
  }
  p.Plain {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 10px;
  }
  .vue-grid-layout {
    border-top: none;
    min-height: 300px;
    height: calc(100vh - 38px - 50px - 62px) !important;
  }
  .vue-grid-item .el-divider--horizontal {
    margin: 12px 0;
  }
  .TableForm {
    height: 100%;
  }
  .el-progress,
  .el-rate {
    line-height: 32px;
  }
  .el-form-item {
    &.el-form--label-top {
      .el-form-item__label {
        width: 100% !important;
      }
      .el-form-item__content {
        margin-left: 0 !important;
      }
      .el-textarea__inner {
        height: calc(100% - 14px);
      }
    }
    &.el-form--label-left {
      .el-form-item__label {
        line-height: 32px !important;
        text-align: right;
        overflow: visible;
        .name {
          line-height: 21px !important;
        }
      }
      .el-form-item__content {
        height: 84% !important;
      }
      &.widget-Textarea {
        .el-form-item__label {
          height: 100%;
          display: flex;
          align-items: center; /*垂直居中*/
          justify-content: flex-end;
        }
      }
    }
    &.el-form--label-none {
      .el-form-item__label {
        display: none;
      }
      .el-form-item__content {
        margin-left: 0 !important;
        height: 84% !important;
      }
    }
  }
  .el-form-item__content {
    height: calc(100% - 36px);
  }
  .el-progress {
    width: 100%;
  }
  .el-progress-circle {
    margin: 0 auto;
  }
  .el-form-item {
    height: 100%;
    margin-bottom: 0 !important;
    padding: 0 5px;
  }
  .vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
  }
  .vue-grid-item .tips {
    line-height: 20px;
    color: #91a1b7;
    font-weight: normal;
  }
  .vue-grid-item .name {
    // line-height: 24px;
    font-weight: normal;
  }
  .vue-grid-item .el-form-item__label {
    padding-bottom: 0px !important;
    line-height: 32px !important;
  }
  .connect-link {
    cursor: pointer;
    text-decoration: underline;
    color: #409eff;
  }
}
</style>
